<template>
  <div class="group">
    <p class="subtitle-2" v-if="!hideLabel">{{ field.label }}</p>
    <configField
      :id="id"
      :category="category"
      v-for="groupField in field.items"
      :key="getFieldId(groupField.id)"
      :field="getFieldData(groupField.id)"
      :value="getConfigValue(groupField.id)"
      :hideLabel="groupField.configHideLabel !== undefined ? groupField.configHideLabel : hideLabel"
      :parentField="parentField"
      :isTemplate="isTemplate"
      :class="field.groupType"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import configField from "@/components/config-field";

import getFieldData from "@/util/getFieldData";

export default {
  name: "Group",
  components: { configField },
  props: {
    category: {
      type: String,
    },
    field: {
      type: Object,
    },
    id: {
      type: String,
    },
    hideLabel: {
      type: Boolean,
    },
    parentField: {
      type: String,
    },
    isTemplate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fieldList() {
      const fieldData =
        this.configTemplate && this.configTemplate[this.category];
      return fieldData && fieldData.AvailableFieldList;
    },
    ...mapGetters({
      mergedConfig: "getMergedConfig",
      configTemplate: "getConfigTemplate",
    }),
  },
  methods: {
    getConfigValue(id) {
      let configValue =
        this.mergedConfig[this.id] && this.mergedConfig[this.id][this.category];
      if (this.parentField !== undefined) {
        configValue =
          configValue &&
          this.mergedConfig[this.id][this.category][this.parentField] &&
          this.mergedConfig[this.id][this.category][this.parentField][id];
      } else {
        configValue =
          configValue && this.mergedConfig[this.id][this.category][id];
      }
      return configValue;
    },
    getFieldData(id) {
      return getFieldData(this.fieldList, id);
    },
    getFieldId(id) {
      const fieldData = this.getFieldData(id);
      if (!fieldData) return '';
      return fieldData.FieldId;
    }
  },
};
</script>

<style lang="scss" scoped>
.group {
  p.subtitle-2 {
    margin-bottom: $input-label-spacing;
  }
  &::v-deep {
    .checklist .config-field {
      margin-bottom: $qvo-spacing-16;
    }
  }
}
</style>